import { CheckoutOrderValidationContext } from "../interfaces/checkout-order-validation.interface";

export enum CheckoutOrderValidationError {
	ProductsUnavailable = 'products-unavailable',
	DeliveryZoneUnavailable = 'delivery-zone-unavailable',
	OrderTypeUnavailable = 'order-type-unavailable',
	OrderDataIncomplete = 'order-data-incomplete',
	StoreClosed = 'store-closed',
	PaymentDataIncomplete = 'payment-data-incomplete',
}

export type CheckoutOrderValidationRule = (
	context: CheckoutOrderValidationContext
) => CheckoutOrderValidationError | null;
